<template>
  <form @submit.prevent="checkForm">
    <div class="field">
      <label class="label">Email</label>
      <div class="control has-icons-left has-icons-right">
        <input
          class="input"
          name="email"
          type="email"
          v-model="email"
          :placeholder="$t('contact.yourEmail')"
          required
        />
        <span class="icon is-small is-left">
          <i class="fas fa-envelope"></i>
        </span>
      </div>
    </div>

    <div class="field">
      <label class="label">{{$t('contact.name')}}</label>
      <div class="control has-icons-left has-icons-right">
        <input
          class="input"
          name="name"
          type="text"
          v-model="name"
          :placeholder="$t('contact.yourName')"
          required
        />
        <span class="icon is-small is-left">
          <i class="fas fa-user"></i>
        </span>
      </div>
    </div>

    <div class="field">
      <label class="label">Message</label>
      <div class="control">
        <textarea
          class="textarea"
          name="message"
          v-model="message"
          :placeholder="$t('contact.yourMessage')"
          required
        ></textarea>
      </div>
    </div>

    <div class="field">
      <div class="control">
        <button class="button is-primary" :disabled="!showSubmitButton">{{$t('contact.send')}}</button>
      </div>
    </div>

    <div class="notification is-primary mt-3" v-if="success">
        {{ $t("contact.thankYou") }}
    </div>
  </form>
</template>

<script>
import axios from "axios";

export default {
  name: "ContactForm",
  data() {
    return {
      email: null,
      name: null,
      message: null,
      success: false,
      showSubmitButton: true
    };
  },
  methods: {
    async checkForm() {
        this.showSubmitButton = false;
        try {
            let key = "VUE_APP_API_URL_" + String(this.$i18n.locale).toUpperCase();
            await axios.post(process.env[key] + "wp-json/blackdigital/v1/contact", {
            name: this.name,
            email: this.email,
            message: this.message
            });
            this.success = true;
        } catch (error) {
            this.success = false;
            this.showSubmitButton = true;
        }
    },
  }
};
</script>